/** Invoice detail — a real route, so it can be linked to and tested by URL. */
import IptDetail from '@/components/ipt/IptDetail';

export default function InvoiceDetailPage() {
  return <IptDetail />;
}
